import React, { useEffect, useState } from 'react'
import { Drawer, Card, Button, Form, Row, Col, Icon, notification } from 'antd'
import {
  formItemLayout,
  InputBox,
  chooseEmailModalFxn
} from '../../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import GetEachFormFields from '../../../../components/_utils/appFormUtils'
import { RevisedAbstract } from '../actions'
import moment from 'moment'

const RevisedAbstractDrawer = (props) => {
  let {
    form: { getFieldDecorator },
    visible,
    onClose,
    abstract,
    callback = null
  } = props
  const dispatch = useDispatch()

  let [revisedAbstractAttachment, setRevisedAbstractAttachment] = useState({})
  let [responseFromAuthorAttachment, setResponseFromAuthorAttachment] = useState({})

  useEffect(() => {
    // Set default date to now
    props.form.setFieldsValue({
      revisedAbstractDate: moment()
    })
  }, [])

  const inputSchema = {
    fields: [
      {
        label: 'Date',
        key: 'revisedAbstractDate',
        required: true,
        placeholder: 'Date of Enter',
        type: 'date'
      },
      {
        label: 'Revised Abstract',
        customField: (
          <InputBox title={`Revised Abstract`} className={'rowFlex'}>
            <input type={'file'} name={'revisedAbstractAttachment'} id={'revisedAbstractAttachment'}
                   className={'form-control'}
                   onChange={(e) => {
                     let { files } = e.target
                     if (files && files.length) setRevisedAbstractAttachment(files[0])
                   }} />
          </InputBox>
        )
      },
      {
        label: 'Response from Author',
        customField: (
          <InputBox title={`Response from Author`} className={'rowFlex'}>
            <input type={'file'} name={'responseFromAuthorAttachment'} id={'responseFromAuthorAttachment'}
                   className={'form-control'}
                   onChange={(e) => {
                     let { files } = e.target
                     if (files && files.length) setResponseFromAuthorAttachment(files[0])
                   }} />
          </InputBox>
        )
      }
    ]
  }

  // const handleSubmit = e => {
  //   const { form } = props
  //   e.preventDefault()
  //   form.validateFieldsAndScroll(async (err, valData) => {
  //     if (err) return notification.error({ message: err.message || 'Error' })
  //
  //     chooseEmailModalFxn({
  //       title: 'Revised Abstract',
  //       callback: async (email) => {
  //         let fd = new FormData()
  //         let obj = {
  //           abstractId: abstract._id,
  //           revisedAbstractDate: valData.revisedAbstractDate,
  //           template: 'revisedAbstractAcknowledgement',
  //           fromEmail: email
  //         }
  //         fd.append('obj', JSON.stringify(obj))
  //
  //         if (revisedAbstractAttachment.name) fd.append('revisedAbstractAttachment', revisedAbstractAttachment)
  //         if (responseFromAuthorAttachment.name) fd.append('responseFromAuthorAttachment', responseFromAuthorAttachment)
  //
  //         let { success } = await dispatch(RevisedAbstract(fd))
  //         if (success) {
  //           onClose()
  //           if (callback) callback()
  //           setRevisedAbstractAttachment({})
  //           setResponseFromAuthorAttachment({})
  //         }
  //       }
  //     })
  //   })
  // }
  const handleSubmit = e => {
    const { form } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (err) return notification.error({ message: err.message || 'Error' })

      chooseEmailModalFxn({
        title: 'Revised Abstract',
        callback: async (email) => {
          let fd = new FormData()
          let obj = {
            abstractId: abstract._id,
            revisedAbstractDate: valData.revisedAbstractDate,
            template: 'revisedAbstractAcknowledgement',
            fromEmail: email
          }
          fd.append('obj', JSON.stringify(obj))

          if (revisedAbstractAttachment.name) fd.append('revisedAbstractAttachment', revisedAbstractAttachment)
          if (responseFromAuthorAttachment.name) fd.append('responseFromAuthorAttachment', responseFromAuthorAttachment)

          let { success } = await dispatch(RevisedAbstract(fd))
          // if (success) {
          //   // 1. Close the drawer
          //   onClose()
          //
          //   // 2. Hard reload to bypass the Ant Design freeze
          //   setTimeout(() => {
          //     window.location.reload()
          //   }, 100)
          // }
          // In RevisedAbstractDrawer.js -> handleSubmit
          if (success) {
            // 1. Close the drawer
            onClose();

            // 2. Wait 500ms for BOTH the Email modal and Drawer to finish sliding away
            setTimeout(() => {
              // 🛡️ ANTI-FREEZE GUARANTEE: Force the browser to unlock scrolling
              document.body.style.overflow = '';

              // 3. Silently fetch the new data
              dispatch({ type: 'START_LOAD_ABSTRACT' });
            }, 500);
          }
        }
      })
    })
  }
  return (
    <Drawer
      title={`Revised Abstract | Abstract No. - ${abstract.abstractNo || abstract.onlineAbstractId || 'N/A'}`}
      width={'35%'}
      visible={visible}
      maskClosable={false}
      placement='right'
      onClose={onClose}>
      <Card>
        <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
          <Row gutter={16}>
            {inputSchema.fields.map((item, key) => (
              <Col span={24} key={key}>
                {item.customField ? item.customField :
                  <GetEachFormFields
                    item={item}
                    getFieldDecorator={getFieldDecorator}
                    formItemLayout={formItemLayout} />}
              </Col>
            ))}
            <Col span={24}>
              <Form.Item style={{ marginTop: 40 }}>
                <Button type='primary' htmlType='submit'>Submit</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

export default Form.create()(RevisedAbstractDrawer)
